<template>
    <div>
<!--        <div v-if="$vuetify.breakpoint.mdAndUp" class="body-2 my-6 text-left">
            {{
                $gettext('For installing the app(s), please double click an app or drag them to your device on the left')
            }}
        </div>
        <div v-else class="body-2 my-6 text-left">
            {{
                $gettext('For installing the app, please tap twice')
            }}
        </div>-->
        <!--        <v-card class="mt-2 mb-16 pa-3 overflow-y-auto" elevation="10" rounded>-->
        <v-card class="mt-2 mb-16 pa-3 overflow-y-auto app-store-card"
                elevation="10" rounded
                @dragover.prevent="handleDragOver"
                @dragenter.prevent="handleDragEnter"
                @dragleave="handleDragLeave">
            <app-store-header-for-usage-time @update:chosenAppSource="val => chosenAppSource = val"
                              @update:appFilterStoreText="val => appFilterStoreText = val"></app-store-header-for-usage-time>

            <v-divider class="mb-3"></v-divider>
            <app-store-messages :appFilterStoreText="appFilterStoreText" :hasApp="hasApp"></app-store-messages>

            <!-- :force-fallback="isSafari" :fallback-class="'drag-fallback'" :fallback-on-body="true" -->
            <draggable v-model="filteredCurrentAppsForStore" :group="{ name: 'apps', pull: 'clone', put: true }"
                       :class="['app-grid-right', { 'delete-zone-draggable': isDraggingToDelete }]" handle=".dragHandle" @clone="handleAppDraggedFromStore" @add="onDroppedFromRestriction"
                       @end="onDragEnd"
                       @start="onDragStart">
                <app-icon v-for="app in filteredCurrentAppsForStore" :id="app.packageId" :key="app.packageId"
                          :app-name="app.appName" :device-name="chosenModel"
                          :folder-name="getPhoneTypeDirForDevice(chosenModel, true, chosenAppSource)"
                          :isAppsSourceDevice="true" :package-name="app.packageId" :show-menu="showMenu" :x="x" :y="y"
                          class="mb-3 mt-2 cursor-move dragHandle"
                          @changeShowMenu="(val) => updateShowMenu(val, app.packageId)" @installApp="installApp"/>
            </draggable>

        </v-card>
    </div>
</template>


<script>
// import Vue from 'vue'
// import { reactive, ref, onMounted } from '@vue/composition-api'
import draggable from 'vuedraggable'
import {computed, onMounted, ref, toRef, watch} from "vue";
import DeviceSearchingText from "@/components/blocks/DeviceSearchingText.vue";
import DeviceNoAppsFound from "@/components/blocks/DeviceNoAppsFound.vue";
import AppIcon from "@/components/devices/AppIcon.vue";
import {storeToRefs} from "pinia";
import {usePhonesStore} from "@/stores/PhonesStore";
import Snackbar from "@/components/Snackbar.vue";
import {usePhoneTypesStore} from "@/stores/PhoneTypesStore";
import {useAppUsageRestrictionsStore} from "@/stores/AppUsageRestrictionsStore";
import {getPhoneTypeDirForDevice} from "@/composables/getPhoneTypeDirForDevice";
import {findIndex, isInteger} from "lodash";
import AppStoreHeaderForUsageTime from "@/components/devices/AppStoreHeaderForUsageTime.vue";
import AppStoreMessages from "@/components/devices/AppStoreMessages.vue";
import {eventBus} from "@/main";

let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export default {
    name: 'AppStore',
    props: {
        chosenModel: String,
        deviceName: String,
        folderName: String,
        isDragging: {
            type: Boolean,
            default: false
        }
    },
    components: {
        AppStoreMessages,
        AppStoreHeaderForUsageTime,
        DeviceNoAppsFound,
        DeviceSearchingText,
        Snackbar,
        AppIcon,
        draggable
    },
    setup(props, context) {

        let appFilterStoreText = ref('');
        let chosenAppSource = ref('system');
        let showMenu = ref({value: false, packageName: ''});
        let x = ref(0);
        let y = ref(0);
        let filteredCurrentAppsForStore = ref([]);
        let isDraggingToDelete = ref(false);
        let isDraggingFromStore = ref(false);
        
        const isDragging = toRef(props, 'isDragging');

        // required prop chosenModel
        /*const chosenModel = toRef(props, 'chosenModel')
        chosenModel.value = props.chosenModel*/

        // props


        // const phoneTypeIndex = toRef(props, 'phoneTypeIndex')

        const phonesStore = usePhonesStore()
        const {
            configurations,
            currentSelectedConfiguration,
            currentSelectedConfigurationIndex,
            chosenModel,
        } = storeToRefs(phonesStore);


        const phoneTypesStore = usePhoneTypesStore()
        const {
            phoneTypes,
            appsCommon,
            phoneTypeIndex,
        } = storeToRefs(phoneTypesStore);

        const appUsageRestrictionsStore = useAppUsageRestrictionsStore()
        const {
            restrictions,
        } = storeToRefs(appUsageRestrictionsStore);


        function getAppsAsPerChosenSource() {
            let apps;
            // Always show system apps (applications) 
            // Common apps from server are no longer supported
            // if (chosenAppSource.value === 'common') {
                // apps = appsCommon.value?.applications?.['all applications'] || [];
            // } else {
                const config = configurations.value[currentSelectedConfigurationIndex.value];
                console.log('Current config:', config);
                // Show installed_applications (system apps)
                // apps = config?.value?.installed_applications || [];
                apps = config?.value?.applications || [];
            // }
            return apps;
        }

        let removeDuplicatePackageForCurrentConfiguration = function (packageId, appName, newIndex = false) {

            let applications = configurations.value[currentSelectedConfigurationIndex.value].value.applications;
            let firstOccurrenceIndex = findIndex(applications, (application, index) => (application.packageId === packageId))

            if (firstOccurrenceIndex > -1) {

                let secondOccurrenceIndex = findIndex(applications, (application, index) => (application.packageId === packageId), firstOccurrenceIndex + 1)

                if (secondOccurrenceIndex > -1 && isInteger(newIndex) && newIndex > -1) {
                    applications.splice(newIndex, 1)
                    // self.$refs.snackbar.showSnackbar(self.$gettext(appName + ' is already installed for the device ' + self.chosenModel), 'info')
                }

            }

        }

        function filteredCurrentApplicationsForStore() {
            let appsAsPerChosenSource = getAppsAsPerChosenSource();

            // Get restrictions from AppUsageRestrictionsStore
            const currentConfig = configurations.value[currentSelectedConfigurationIndex.value];
            const mdmDeviceId = currentConfig?.value?.userInfo?.mdmDeviceId;
            const restrictionData = restrictions.value[mdmDeviceId];
            const restrictionsList = restrictionData?.rules || [];

            const appsInRestrictions = restrictionsList.reduce((acc, restriction) => {
                if (restriction.apps) {
                    acc.push(...restriction.apps.map(app => app.packageId));
                }
                return acc;
            }, []);

            if (appsInRestrictions.length > 0) {
                appsAsPerChosenSource = appsAsPerChosenSource.filter(app =>
                    !appsInRestrictions.includes(app.packageId)
                );
            }

            // Apply search filter
            if (appFilterStoreText.value.length > 0) {
                appsAsPerChosenSource = appsAsPerChosenSource.filter(app =>
                    app.appName.toLowerCase().includes(appFilterStoreText.value.toLowerCase())
                );
            }

            return appsAsPerChosenSource;
        }

        filteredCurrentAppsForStore.value = filteredCurrentApplicationsForStore();

        let hasApp = computed(() => {

            let filteredApps = filteredCurrentAppsForStore.value;

            if (filteredApps?.length > 0) {
                return true;
            }

            return false;

        });

        let updateShowMenu = function (val, packageName) {

            // TODO: This if is no help, remove it.
            if (val.packageName === packageName) {

                self.$set(showMenu, 'value', val.value)
                self.$set(showMenu, 'packageName', val.packageName)

                x = val.x
                y = val.y

            }

        }

        /*let installApp = function (packageId) {

            let appStoreApps = getAppsAsPerChosenSource();
            let appToBeInstalled = appStoreApps.filter((application) => application.packageId.toLowerCase().includes(packageId.toLowerCase()))

            if (appToBeInstalled?.length > 0) {
                let applications = configurations.value[currentSelectedConfigurationIndex.value].value.applications;
                applications.splice(0, 0, appToBeInstalled[0])
                removeDuplicatePackageForCurrentConfiguration(appToBeInstalled[0].packageId, appToBeInstalled[0].appName, 0)
            }

            // eventBus emit event to update the app list on the left side
            eventBus.$emit('update-app-list', currentSelectedConfiguration.value)
            refreshAppStoreApps()
        }*/

        let installApp = function (packageId) {
            let appStoreApps = getAppsAsPerChosenSource();
            let appToBeInstalled = appStoreApps.filter((application) =>
                application.packageId.toLowerCase().includes(packageId.toLowerCase())
            );

            if (appToBeInstalled?.length > 0) {

                let applications = configurations.value[currentSelectedConfigurationIndex.value].value.applications;
                applications.splice(0, 0, appToBeInstalled[0]);
                removeDuplicatePackageForCurrentConfiguration(appToBeInstalled[0].packageId, appToBeInstalled[0].appName, 0);

                /*
                let availableApps = configurations.value[currentSelectedConfigurationIndex.value].value.installed_applications;
                const appIndex = findIndex(availableApps, application => application.packageId === packageId);

                if (appIndex > -1) {
                    availableApps.splice(appIndex, 1);
                }
                 */
            }

            eventBus.$emit('update-app-list', currentSelectedConfiguration.value);
            refreshAppStoreApps();
        }

        let refreshLeftDeviceAppList = function () {
            eventBus.$emit('update-app-list', currentSelectedConfiguration.value)
        }

        let refreshAppStoreApps = function () {
            filteredCurrentAppsForStore.value = filteredCurrentApplicationsForStore();
        }

        let showAppIfNotInstalledAlready = function (packageId) {

            let applications = configurations.value[currentSelectedConfigurationIndex.value].value.applications;
            let appAlreadyInstalled = applications.some((app) => app.packageId === packageId)

            if (appAlreadyInstalled) {
                return false;
            }

            return true;

        }

        let handleAppDraggedFromStore = function (evt) {
            refreshAppStoreApps();
        }

        const onDragMove = (evt) => {

            // FIXME: Temporarily disabled
            if (1 === 2) {

                const fallback = document.querySelector('.drag-fallback');

                if (!fallback) {
                    console.warn('WARNING: Fallback element not found during drag move.');
                    return;
                }



                if (fallback) {
                    fallback.style.top = `${evt.clientY}px`;
                    fallback.style.left = `${evt.clientX}px`;
                    fallback.style.transform = 'translate(-50%, -50%)';
                }

            }

        };

        const handleDragEnter = (evt) => {
            if (isDragging?.value && !isDraggingFromStore.value && evt.dataTransfer) {
                evt.dataTransfer.dropEffect = 'move';
                isDraggingToDelete.value = true;
            }
        };

        const handleDragOver = (evt) => {
            if (isDragging?.value && !isDraggingFromStore.value && evt.dataTransfer) {
                evt.dataTransfer.dropEffect = 'move';
                isDraggingToDelete.value = true;
            }
        };

        const handleDragLeave = (evt) => {
            if (!evt.currentTarget.contains(evt.relatedTarget)) {
                isDraggingToDelete.value = false;
            }
        };

        const onDragStart = (evt) => {
            isDraggingFromStore.value = true;

            if (isSafari && evt.originalEvent && evt.originalEvent.dataTransfer) {
                const transparentPixel = document.createElement('div');
                transparentPixel.style.width = '1px';
                transparentPixel.style.height = '1px';
                transparentPixel.style.opacity = '0';
                evt.originalEvent.dataTransfer.setDragImage(transparentPixel, 0, 0);
            }

            // FIXME: Temporarily disabled
            if (isSafari && 1 === 2) {

                if (!evt.item) {
                    // FIXME: REMOVE THIS
                    console.error('ERROR: evt.item is undefined. Dragging might not have been initialized properly.');
                    return;
                }

                document.addEventListener('mousemove', onDragMove);

                const fallback = evt.item.cloneNode(true);
                fallback.classList.add('drag-fallback');
                fallback.style.position = 'fixed';
                fallback.style.top = `${evt.clientY}px`;
                fallback.style.left = `${evt.clientX}px`;
                fallback.style.transform = 'translate(-50%, -50%)';
                fallback.style.pointerEvents = 'none';
                fallback.style.zIndex = '10000';

                document.body.appendChild(fallback);
                evt.item._fallback = fallback;

            }

            context.emit('drag-started');

        };


        const onDragEnd = (evt) => {
            isDraggingToDelete.value = false;
            isDraggingFromStore.value = false;

            // FIXME: Temporarily disabled
            if (1 === 2) {

                document.removeEventListener('mousemove', onDragMove);

                if (evt.item._fallback) {
                    evt.item._fallback.remove();
                    delete evt.item._fallback;
                }

            }

            context.emit('drag-ended');
        };

        watch(isDragging, (newVal) => {
            if (!newVal) {
                isDraggingToDelete.value = false;
                isDraggingFromStore.value = false;
            }
        });

        const onDroppedFromRestriction = (evt) => {
            isDraggingToDelete.value = false;
            const idx = evt?.newIndex;
            if (idx == null) {
                return;
            }
            const dropped = filteredCurrentAppsForStore.value[idx];
            if (dropped && dropped.packageId) {
                context.emit('app-removed-from-restriction', dropped);
            }
            filteredCurrentAppsForStore.value.splice(idx, 1);
            refreshAppStoreApps();
        };

        eventBus.$on('app-deleted', (packageId) => {
            refreshAppStoreApps()
        })

        watch(chosenAppSource, (val) => {
            refreshAppStoreApps()
        })
        watch(appFilterStoreText, (val) => {
            refreshAppStoreApps()
        })
        watch(currentSelectedConfiguration, (val) => {
            refreshAppStoreApps()
        })

        onMounted(() => {
            
        });

        return {
            appFilterStoreText,
            phoneTypes,
            phoneTypeIndex,
            configurations,
            currentSelectedConfiguration,
            currentSelectedConfigurationIndex,
            chosenModel,
            chosenAppSource,
            showMenu,
            getPhoneTypeDirForDevice,
            x,
            y,
            updateShowMenu,
            appsCommon,
            installApp,
            removeDuplicatePackageForCurrentConfiguration,
            hasApp,
            refreshLeftDeviceAppList,
            filteredCurrentAppsForStore,
            refreshAppStoreApps,
            showAppIfNotInstalledAlready,
            handleAppDraggedFromStore,
            onDragStart,
            onDragEnd,
            isSafari,
            onDroppedFromRestriction,
            isDraggingToDelete,
            handleDragEnter,
            handleDragOver,
            handleDragLeave
        }
    }
}
</script>
<style type="text/scss">
.app-grid-right {
    display: grid;
    /* grid-template-columns: repeat(5, 1fr); grid-column-gap: 40px; grid-row-gap: 10px; */
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));

    /* grid-template-rows: repeat(3, 1fr); grid-template-rows: repeat(6, 1fr); row-gap: 20px; column-gap: 10px; */

    position: relative !important;

}

.app-store-card {
    max-height: 400px;
    overflow-y: auto;
}

.sortable-ghost {
    pointer-events: none !important;
    /* Prevent interaction with the ghost */
    opacity: 0.8 !important;
    /* Make it semi-transparent */
    transform: scale(0.95) !important;
    /* Slightly shrink the ghost */
    width: 80px !important;
    /* Constrain the width */
    height: 80px !important;
    /* Constrain the height */
    border-radius: 8px !important;
    /* Match the original element's style */
    overflow: hidden !important;
    /* Prevent content overflow */
}

.drag-fallback {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    transform: translate(-50%, -50%) !important;
    pointer-events: none !important;
    z-index: 10000 !important;
    width: 80px !important;
    height: 80px !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
    background-color: white !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.sortable-ghost,
.drag-fallback {
    width: 80px !important;
    height: 80px !important;
    overflow: hidden !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
    opacity: 0.9 !important;
    pointer-events: none !important;
    transform: translate3d(0, 0, 0) !important;
    -webkit-transform: translate3d(0, 0, 0) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    background-color: white !important;
}

.delete-zone-active {
    border: 2px dashed #f44336 !important;
    background-color: rgba(244, 67, 54, 0.05) !important;
    transition: all 0.2s ease !important;
}

.delete-zone-draggable {
    border: 2px dashed #f44336 !important;
    background-color: rgba(244, 67, 54, 0.05) !important;
    transition: all 0.2s ease !important;
}

.delete-zone-active .sortable-ghost {
    border: 2px solid #f44336 !important;
    background-color: rgba(244, 67, 54, 0.1) !important;
}

.delete-zone-active ::v-deep .sortable-drag,
.delete-zone-draggable ::v-deep .sortable-drag {
    border: 2px solid #f44336 !important;
    opacity: 0.7 !important;
    box-shadow: 0 0 8px rgba(244, 67, 54, 0.4) !important;
}
</style>
